import { Component, OnInit, ViewChild, ElementRef, EventEmitter, Input } from '@angular/core';
import { WbService } from '../wb.service';
import { TranslateService } from 'ng2-translate/ng2-translate';
import { WhiteBoardComponent } from "../white-board.component";
import { SessionManagerService } from "../services/session/session-manager.service";
import { RecordingManagerService } from "../services/recording/recording-manager.service";
import { LayoutManagerService } from "../services/layout/layout-manager.service";
import {LogService} from "../services/log/log.service";

import { PermissionsManagerService } from "../services/permissions/permissions-manager.service";
declare var $;
declare var MQ;
declare var MathQuill;
@Component({
  selector: "dskl-wb-algebra",
  templateUrl: 'algebra-wb.component.html',
  styleUrls: ["algebra.css"],
  inputs: ["board"],
  outputs: ["change"], 
  
})

export class AlgebraWbComponent extends WhiteBoardComponent {

  rows = [];
  currentRow = 0;
  @ViewChild('rowsEl') rowsEl: ElementRef;
  clearStates() {
    var MQ = MathQuill.getInterface(2); 
    for (let i = 0; i < 20; i++) {
      var row = $("#wb-formula" +/* this.board.pageId*/ + i);
      var r = MQ(row[0]);
      r.latex("");
    }
  }
  onCurrentPageState(state, pageId) {
    var MQ = MathQuill.getInterface(2);
    console.log("set state", state)
    if (!state) return;

    for (let k in state) {
      var row = $("#wb-formula" + k);
      var r = MQ(row[0]);
      if (state[k] && state[k].length > 0)
        r.latex(state[k])
    }
  }
  getCurrentState() {
    console.log("Getting curren state")
    var MQ = MathQuill.getInterface(2)
    var states = {}
    for (var i = 0; i < 20; i++) {
      var row = $("#wb-formula" + i);
      states[i] = MQ(row[0]).latex();
    }
    return states;
  }
  onReady() {
    console.log("Will register fo " + this.board.pageId)

    for (let i = 0; i < 20; i++) {
      this.rows[i] = {};
    }
    this.translatePageName();
  }
  private write(str, r, clear) {
    var MQ = MathQuill.getInterface(2);
    var row = $("#wb-formula" +/* this.board.pageId*/ + r);
    var r = MQ(row[0]);
    if (clear)
      r.latex(str)
    else
      r.write(str)

    return r;

  }
  translatePageName() {
    this.translate.get('WB_PAGE_NAME.PAGE_ALGEBRA').subscribe((res: string) => { this.pageName = res; });
  }
  getWbType() {
    return this.pageName;
  }
  pageName = "Алгебра";
  onTool(e) {
    var r = this.write(e.str, this.currentRow, false);
    this.changed("formula", { "formula": r.latex(), "row": this.currentRow });
    r.focus();
  }
  constructor(protected log: LogService, protected wbService: WbService, private translate: TranslateService, protected sessionManager: SessionManagerService, protected layoutManagerService: LayoutManagerService, protected permissionsManager: PermissionsManagerService) {
    super(log, wbService, sessionManager, layoutManagerService, permissionsManager);
  }
  onUpdate(){
  
  }
  onResize() {

  }
  onViewReady() {
    console.log("after view init")
    // var h = $("body").height() - (this.topLayout ? $("#videos").height() - 136 : 0);
    //TODO: 
    $(this.rowsEl.nativeElement).css("height", $("body").height());
    var MQ = MathQuill.getInterface(2);
    var self = this;
    $(this.rowsEl.nativeElement).children().each(function (k, v) {
      console.log("Registering row")
      var r = MQ.MathField(v);
      $(r.el()).on("keyup", function (e) {
        console.log(r.latex());
       // self.emitOnMathRow(r.latex(), self.currentRow);
        self.changed("formula", { "formula": r.latex(), "row": self.currentRow });
        //WbMath.changed(r.latex());
      });
    });
    var self = this;

  }
  onDrawMathRow(){
    console.log("Will draw the function")
     var row = $("#wb-formula" +/* this.board.pageId*/ + this.currentRow);
     var MQ = MathQuill.getInterface(2);
     var r = MQ(row[0]);
     this.emitOnMathRow(r.latex(), this.currentRow);
  }
  private emitOnMathRow(str, row) {
    console.log("Will call math row");
    this.wbService.onMathRow(str, row);
  }
  changing: boolean = false;
  onState(state, pageId) {
    console.log("Gettin state");
    if (pageId != this.board.pageId) {
      console.log("Not for me " + this.board.pageId + " but for " + pageId);
      console.log(state);
      return;
    }
    var w = state.value.formula;
    var r = state.value.row;
    this.write(w, r, true);
    this.emitOnMathRow(w, r);
  }
  private changed(type, value = null) {
    this.emitChanged({ type: type, value: value });
  }

}



// WEBPACK FOOTER //
// /app/src/app/wb/algebra/algebra-wb.component.ts